import * as React from 'react'

import { TripEventType } from '@/app/constants/delegation/tripEventType'

import { useTimelineData } from '../context/DataContext'
import { useConfig } from '../context/ConfigContext'
import { MinimalPaymentCountryBlock } from '../blocks/MinimalPaymentCountryBlock'
import { LayerWrapper } from './LayerWrapper'
import { toMs } from './lanes'
import { LayerProps } from './types'

const MinimalPaymentCountriesLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const { minimalPaymentCountries, allEvents, violations } = useTimelineData()
  const { minimalPaymentSuppressedPerSpan } = useConfig()

  const loadUnloadTimes = React.useMemo(
    () =>
      (allEvents || [])
        .filter(
          (a) =>
            a.tripEvent == TripEventType.Loading ||
            a.tripEvent == TripEventType.Unloading,
        )
        .map((a) => toMs(a.date))
        .filter((t) => !isNaN(t)),
    [allEvents],
  )


  const isSupersededByTms = (start: any, end: any): boolean => {
    if (!minimalPaymentSuppressedPerSpan) return false
    const s = toMs(start)
    const e = toMs(end)
    if (isNaN(s) || isNaN(e)) return false
    return loadUnloadTimes.some((t) => t > s && t < e)
  }

  const violationSpans = React.useMemo(
    () =>
      (violations || [])
        .map((v: any) => ({ s: toMs(v.startTime), e: toMs(v.endTime) }))
        .filter((sp) => !isNaN(sp.s) && !isNaN(sp.e) && sp.e > sp.s),
    [violations],
  )

  const overlapsViolation = (start: any, end: any): boolean => {
    const s = toMs(start)
    const e = toMs(end)
    if (isNaN(s) || isNaN(e)) return false
    return violationSpans.some((v) => v.s < e && v.e > s)
  }

 
  if (!minimalPaymentSuppressedPerSpan && loadUnloadTimes.length > 0) return null

  return (
    <LayerWrapper zIndex={zIndex}>
      {minimalPaymentCountries
        .filter((item) => !isSupersededByTms(item.startTime, item.endTime))
        .map((item, index) => (
          <MinimalPaymentCountryBlock
            key={index}
            minimalPaymentCountry={item}
            index={index}
            belowViolation={overlapsViolation(item.startTime, item.endTime)}
          />
        ))}
    </LayerWrapper>
  )
}

export default MinimalPaymentCountriesLayer
